import React, { useEffect, useState } from "react";
import axios from "axios";

import "./featured.css";

const Featured = () => {
  const [featuredContent, setFeaturedContent] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchFeaturedContent = async () => {
      try {
        const response = await axios.get("http://localhost:5000/api/featured");
        if (Array.isArray(response.data)) {
          setFeaturedContent(response.data);
        } else {
          console.warn("Expected an array but received:", response.data);
          setFeaturedContent([]);
        }
      } catch (error) {
        console.error("Error fetching featured content:", error);
        setError("Could not load featured content. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    fetchFeaturedContent();
  }, []);

  return (
    <div className="featured-container">
      <h1 className="featured-title">Featured Content</h1>
      {loading ? (
        <div className="loading-spinner">Loading...</div>
      ) : error ? (
        <p className="error-message">{error}</p>
      ) : featuredContent.length > 0 ? (
        <div className="featured-content">
          {featuredContent.map((item) => (
            <div key={item.id} className="featured-item">
              <img
                src={item.image}
                alt={item.title}
                onError={(e) => {
                  e.target.src = "https://via.placeholder.com/150";
                }}
              />
              <h2 className="featured-item-title">{item.title}</h2>
              <p className="featured-item-description">{item.description}</p>
            </div>
          ))}
        </div>
      ) : (
        <p>No featured content available.</p>
      )}
    </div>
  );
};

export default Featured;
